import { useSelector } from "react-redux";
import { RootState } from "../state/root-reducer";

const useIsIOCConverted = () => {
  const selectedEncounter = useSelector((state: RootState) => state.patientContext.selectedEncounter);
  return selectedEncounter?.workflow?.workflowId === 3;
}

export default useIsIOCConverted;